import Column from '../../core/components/box/column';
import SizedBox from '../../core/components/box/sizedBox';
import LXInput from '../../core/texts/lxInput';
import { LXbody, LXCaption, LXh2 } from '../../core/texts/lxText';
import { ReactComponent as KlabLogo } from '../../../assets/logos/klabLogo.svg';
import { useTheme } from 'styled-components';
import LXLargeButton from '../../core/components/buttons/lxLargeButton';
import useResetPageController from '../../../1_application/auth/resetPageController';
import { useEffect } from 'react';

const ResetForm: React.FC = () => {
  const theme = useTheme();
  const r = useResetPageController();

  useEffect(() => {
    const handleEnter = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && r.buttonRef.current)
        r.buttonRef.current.click();
    };
    window.addEventListener('keydown', handleEnter);
    return () => window.removeEventListener('keydown', handleEnter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Column>
      <KlabLogo width={107} height={40}></KlabLogo>
      <SizedBox height={20}></SizedBox>
      <LXh2>{theme.texts.createNewPassword}</LXh2>
      <LXCaption>{theme.texts.enterANewPasswordBelow}</LXCaption>
      <SizedBox height={40}></SizedBox>
      <LXbody>{theme.texts.newPassword}</LXbody>
      <SizedBox height={8}></SizedBox>
      <LXInput
        type="password"
        tabIndex={1}
        validate={r.validateNewPassword}
        onValidate={r.onValidateNewPassword}
        onChange={r.handleNewPasswordInput}
        width={320}
        placeholder={theme.texts.enterNewPassword}
      ></LXInput>
      <SizedBox height={24}></SizedBox>
      <LXbody>{theme.texts.confirmPasword}</LXbody>
      <SizedBox height={8}></SizedBox>
      <LXInput
        type="password"
        tabIndex={2}
        validate={r.validateConfirmPassword}
        onValidate={r.onValidateConfirmPassword}
        onChange={r.handleConfirmPasswordInput}
        width={320}
        placeholder={theme.texts.reEnterPassword}
      ></LXInput>
      <SizedBox height={40}></SizedBox>
      <LXLargeButton
        tabIndex={3}
        refProp={r.buttonRef}
        disabled={r.validationNewPassword || r.validationConfirmPassword}
        onClick={r.sendResetPasswordRequest}
      >
        {theme.texts.changePassword}
      </LXLargeButton>
    </Column>
  );
};

export default ResetForm;
